import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

export default class extends Controller {
  connect() {
    // Prevent infinite reconnect loop
    if (this.element.dataset.choicesInitialized === "true") {
      return;
    }

    this.element.dataset.choicesInitialized = "true";

    const classes = this.element.dataset.choicesContainerOuterClass;

    this.choices = new Choices(this.element, {
      allowHTML: true,
      removeItems: true,
      removeItemButton: true,
      classNames: classes
        ? { containerOuter: classes.split(/\s+/).filter(Boolean) }
        : undefined,
    });
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy();
      this.choices = null;
    }
  }
}